import React, { useState, useCallback, useRef } from 'react';

export default function UploadPanel({ onGenerate, loading }) {
  const [files, setFiles] = useState([]);
  const [text, setText] = useState('');
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef(null);

  const openPicker = () => inputRef.current?.click();

  const addFiles = (newFiles) => {
    const arr = Array.from(newFiles);
    if (arr.length) setFiles(prev => [...prev, ...arr]);
  };

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setDragOver(false);
    addFiles(e.dataTransfer.files);
  }, []);

  const removeFile = (index) => {
    setFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    if (!files.length && !text.trim()) return;
    onGenerate(files, text);
  };

  return (
    <div className="upload-panel">
      <div
        className={`drop-zone ${dragOver ? 'drop-zone--active' : ''}`}
        onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
        onClick={openPicker}
        role="button"
        tabIndex={0}
        aria-label="Upload files"
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openPicker(); }}
      >
        <input
          ref={inputRef}
          type="file"
          accept=".txt,.pdf,.docx,.xlsx,.xls,.pptx,.ppt,.png,.jpg,.jpeg,.gif,.webp"
          multiple
          hidden
          onChange={(e) => { addFiles(e.target.files); e.target.value = ''; }}
        />
        <div className="drop-zone__icon">📄</div>
        {files.length === 0 && (
          <p className="drop-zone__text">Drag & drop files here or click to browse<br/>
            <span className="drop-zone__hint">.txt, .pdf, .docx, .xlsx, .pptx, .png, .jpg, .gif, .webp</span></p>
        )}
        {files.length > 0 && (
          <p className="drop-zone__filename">{files.length} file{files.length > 1 ? 's' : ''} selected — click to add more</p>
        )}
      </div>

      {files.length > 0 && (
        <div className="file-list">
          {files.map((f, i) => (
            <div key={i} className="file-list__item">
              <span className="file-list__name">{f.name}</span>
              <button
                className="file-list__remove"
                onClick={(e) => { e.stopPropagation(); removeFile(i); }}
                aria-label={`Remove ${f.name}`}
              >✕</button>
            </div>
          ))}
          <button className="file-list__clear" onClick={() => setFiles([])}>Clear all</button>
        </div>
      )}

      <div className="divider"><span>OR</span></div>

      <textarea
        className="text-input"
        placeholder="Paste additional context here (optional)..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={6}
        aria-label="Paste text content"
      />

      <button className="btn-primary" onClick={handleSubmit} disabled={loading}>
        {loading ? 'Generating...' : 'Generate Presentation'}
      </button>
    </div>
  );
}
